import React, { useState } from "react";
import { Button } from "./ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Share2, Copy, Check, Linkedin, Twitter, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export default function ShareButton({ url, title, label = "Share", variant = "outline", testId = "share-btn" }) {
  const [copied, setCopied] = useState(false);
  const fullUrl = url?.startsWith("http") ? url : `${window.location.origin}${url}`;
  const shareTitle = title || "Check this out on QaTestology";

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      toast.success("Link copied!");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Copy failed — please copy manually");
    }
  };

  const enc = encodeURIComponent;
  const links = [
    { Icon: Linkedin, label: "LinkedIn", href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(fullUrl)}` },
    { Icon: Twitter, label: "X / Twitter", href: `https://twitter.com/intent/tweet?text=${enc(shareTitle)}&url=${enc(fullUrl)}` },
    { Icon: MessageCircle, label: "WhatsApp", href: `https://wa.me/?text=${enc(shareTitle + " " + fullUrl)}` },
  ];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size="sm" data-testid={testId} className="gap-2">
          <Share2 className="h-4 w-4" /> {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuItem onClick={copy} data-testid={`${testId}-copy`}>
          {copied ? <Check className="h-4 w-4 mr-2 text-emerald-600" /> : <Copy className="h-4 w-4 mr-2" />}
          {copied ? "Copied!" : "Copy link"}
        </DropdownMenuItem>
        {links.map(({ Icon, label, href }) => (
          <DropdownMenuItem key={label} onClick={() => window.open(href, "_blank", "noopener,noreferrer")} data-testid={`${testId}-${label.toLowerCase().replace(/[^a-z]/g, "")}`}>
            <Icon className="h-4 w-4 mr-2" /> {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
